/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useState, useCallback } from 'react';

export const useUpdateState = (initialState) => {
  const [state, setState] = useState(initialState);
  
  const updateState = useCallback((newState) => {
    setState(prevState => ({
      ...prevState,
      ...newState
    }));
  }, []);
  
  return [state, updateState, setState];
};
